<template>
  <div class="container">
    <h4 class="cardD">Cotización</h4>

    <h4 class="cardD">Resumen de Notificación</h4>

    <table class="table table-bordered table-hover table-fixed">
      <thead class="">
        <tr>
          <th class="check-col">Check</th>
          <th class="descripcion-col">Descripción</th>
          <th class="precio-col">Precio</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="">✓</td>
          <td class="">Costo por zona indicada</td>
          <td class="font-weight-bold precio-col-container">{{ formattedCostoZona }}</td>
        </tr>
      </tbody>
    </table>

    <h4 class="cardD mt-1" v-if="subtotal_documentos > 0">Documentos</h4>
    <div class="mt-2" v-if="cantidad_documentos_adicionales > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ cantidad_documentos_adicionales }}</td>
            <td class="">Documentos Adicionales</td>
            <td class="font-weight-bold precio-col-container">{{ formattedDocumentosAdicionales }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="" v-if="notificacion.fad">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Firma Autógrafa Digital</td>
            <td class="font-weight-bold precio-col-container">{{ formattedFad }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mt-2" v-if="paginas_extra > 0">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Cantidad</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">{{ paginas_extra }}</td>
            <td class="">Páginas Adicionales</td>
            <td class="font-weight-bold precio-col-container">{{ formattedPaginasExtra }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="" v-if="notificacion.contenido_digital">
      <table class="table table-bordered table-hover table-fixed">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Contenido Digital</td>
            <td class="font-weight-bold precio-col-container">{{ formattedContenidoDigital }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="cardD">Agregar Extras</h4>

    <div class="row mt-4">
      <div class="col-md-12">
        <div style="display: flex; align-items: center">
          <b-form-checkbox v-model="notificacion.acta_express" :disabled="isCotizacionDisabled">
            Generación de acta y entregable en plazo de 2-4 días hábiles
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <div style="display: flex; align-items: center">
          <b-form-checkbox v-model="notificacion.envio_domicilio" :disabled="isCotizacionDisabled">
            Envío a domicilio del entregable
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <hr v-if="subtotal_extras > 0" />

    <h4 class="cardD" v-if="subtotal_extras > 0">Extras</h4>

    <div class="" v-if="notificacion.acta_express">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" class="">✓</td>
            <td class="">Generación de acta y entregable en plazo de 2-4 días hábiles</td>
            <td class="font-weight-bold precio-col-container">{{ formattedActaExpress }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="" v-if="notificacion.envio_domicilio">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th calss="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" class="">✓</td>
            <td class="">Envío a domicilio del entregable</td>
            <td class="font-weight-bold precio-col-container">$ 500.00</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="cardD mt-1" v-if="notificacion.envio_domicilio">Descuentos</h4>
    <div class="" v-if="notificacion.envio_domicilio">
      <table class="table table-bordered table-hover">
        <thead class="">
          <tr>
            <th class="check-col">Check</th>
            <th class="descripcion-col">Descripción</th>
            <th class="precio-col">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="">✓</td>
            <td class="">Envío a domicilio del entregable</td>
            <td class="font-weight-bold precio-col-container">- $500.00</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h4 class="cardD mt-1">Cupones</h4>
    <div class="row">
      <div class="col-12">
        <base-input
          type="text"
          label="Si cuenta con un cupón puede aplicarlo."
          placeholder="Cupón de descuento"
          :disabled="cuponAplicado && isCotizacionDisabled"
          v-model="nombreCuponDescuento"
        ></base-input>
      </div>
      <div class="col-12 d-flex">
        <br />
          <b-button
            class="orange-btn"
            size="m"
            :disabled="(cuponAplicado || !nombreCuponDescuento) && isCotizacionDisabled"
            @click="validarCupon"
          >
            Aplicar
          </b-button>
      </div>
    </div>

    <div class="mt-1" v-if="cuponAplicado">
      <div class="container">
        <div class="row justify-content-end">
          <div class="col-3">
            <table class="table table-bordered table-hover">
              <thead class="">
                <tr>
                  <th class="precio-col">Descuento del cupón {{ cantidadDescuentoCupon }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="font-weight-bold precio-col-container">{{ formattedValorCupon }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <h4 class="cardD mt-3 font-weight-bold">{{ textoTotalAPagar }}</h4>
      <div class="mt-2">
        <div class="font-weight-bold total">
          <div>
            <p class="orange-text">{{ formattedTotal }}</p>
          </div>
        </div>
      </div>
    </div>

    <h4 class="cardD">Referencia</h4>
    <div class="row">
      <div class="col-md-6">
        <ValidationProvider name="referencia" rules="max:50" v-slot="{ errors }"
          :custom-messages="{ max: 'Máximo 50 caracteres' }">
          <base-input type="text"
          label="Si tiene un número de referencia, por favor incluirlo en el siguiente cuadro."
          placeholder="Máx. 50 caracteres" v-model="notificacion.referencia">
          </base-input>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <hr />

    <div class="row mt-4" v-for="clausula in clausulasConfirmacion" :key="clausula.id">
      <div class="col-md-12 d-flex">
        <ValidationProvider
          name="validacionDatos"
          :rules="{ required: { allowFalse: false } }"
          v-slot="{ errors }"
          :custom-messages="{ required: 'La confirmación es obligatoria' }"
        >
          <div style="display: flex">
            <b-form-checkbox
              class="orange"
              v-model="clausula.confirmado"
              :id="'checkbox-validacionDatos-' + clausula.id"
              :disabled="isCotizacionDisabled"
            >
              {{ clausula.contenido }}
            </b-form-checkbox>
          </div>
          <span class="cardErrors">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="mt-4 d-flex justify-content-end">
      <div class="row">
        <div class="col-12">
          <!-- <b-button type="submit" class="orange-btn" size="m" :disabled="isCotizacionDisabled">
            Confirmar cotización y proceder al pago
          </b-button> -->
          <b-button type="submit" class="orange-btn" size="m">
            Continuar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CatGastosApi, CuponesApi } from "@/api";
import { formatCurrency } from "@/utils/number-utils";

import { useNotificacionStore, useUIStateStore } from "@/stores";

export default {
  name: "CotizacionNotificacion",

  props: {
    notificacion: { type: Object },
    clausulasConfirmacion: {
      type: Array,
      default: () => [],
    },
    isEditNotificacion: {
      type: Boolean,
      default: false,
    },
    cotizacion: {
      type: Object,
      default: () => {},
    },
  },

  setup() {
    const uiState = useUIStateStore();

    return { uiState };
  },

  mounted() {
    this.uiState.startLoading();

    this.getGastos()
      .then(() => {
        if (this.isEditNotificacion) {
          this.fillCotizacion();
          return;
        }

        // this.calculaDocumentos();
        // this.calcularCostoAntesExtrasDescuentos();
        // this.calcularCostoConExtras();
        // this.calcularCostoTotal();

        // this.notificacion.cotizacion.isCalculated = true;
      })
      .finally(() => this.uiState.stopLoading());
  },

  data() {
    return {
      loading: false,

      // Costos en BD
      cat_gastos: [],
      precio_acta: 0,
      precio_adicional_fisica: 0,
      precio_adicional_moral: 0,
      precio_adicional_representante: 0,
      precio_fad: 0,
      precio_pagina_adicional: 0,
      precio_contenido_digital: 0,
      precio_documento_adicional: 0,
      // Costos pre-calculados
      precio_zona: 0,

      // Cantidades
      cantidad_adicionales_fisicas: 0,
      cantidad_adicionales_morales: 0,
      cantidad_adicionales_representantes: 0,
      cantidad_documentos_adicionales: 0,
      paginas_totales: 0,
      paginas_extra: 0,

      // Costos totales = Cantidad * Precio
      precio_total_documentos_adicionales: 0,
      precio_total_paginas_extra: 0,

      // Subtotales
      subtotal_zona: 0,
      subtotal_solicitantes: 0,
      subtotal_documentos: 0,
      subtotal_extras: 0,

      nombreCuponDescuento: "",
      cuponAplicado: false,
      cantidadDescuentoCupon: "",
      cantidadDescontadaCupon: 0,
      costoTotal: 0,

    };
  },

  watch: {
    "notificacion.acta_express": "recalcularExtrasHandler",
    "notificacion.envio_domicilio": "recalcularExtrasHandler"
  },

  computed: {
    formattedCostoZona() {
      return formatCurrency(this.notificacion.cotizacion.conceptos.domicilio_notificacion.precio);
    },
    formattedDocumentosAdicionales() {
      return formatCurrency(this.precio_total_documentos_adicionales);
    },
    formattedFad() {
      return formatCurrency(this.precio_fad);
    },
    formattedPaginasExtra() {
      return formatCurrency(this.precio_total_paginas_extra);
    },
    formattedContenidoDigital() {
      return formatCurrency(this.precio_contenido_digital);
    },
    formattedActaExpress() {
      return formatCurrency(this.precio_acta);
    },
    formattedSubtotalExtras() {
      return formatCurrency(this.subtotal_extras);
    },
    formattedTotal() {
      return formatCurrency(this.notificacion.cotizacion.conceptos.costo_total);
    },
    textoTotalAPagar() {
      let texto = "Total a pagar";
      if ((this.notificacion.acta_express || this.notificacion.envio_domicilio) && this.cuponAplicado) {
        texto += " con extras y descuentos";
      } else if (!this.notificacion.acta_express && !this.notificacion.envio_domicilio && this.cuponAplicado) {
        texto += " con descuento";
      } else if (this.notificacion.acta_express || this.notificacion.envio_domicilio) {
        texto += " con extras";
      }
      return texto;
    },
    formattedValorCupon() {
      return formatCurrency(this.cantidadDescontadaCupon * -1);
    },

    isCotizacionDisabled() {
      // if (this.isEditNotificacion) {
      //   return !!this.notificacion.cotizacion.pagado;
      // }

      // return false;
      return this.isEditNotificacion;
    },
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    recalcularExtrasHandler() {
      const conceptos = this.notificacion.cotizacion.conceptos;

      conceptos.acta_express.precio = this.precio_acta;
      if (this.notificacion.acta_express) {
        conceptos.acta_express.cantidad = 1;
      } else {
        conceptos.acta_express.cantidad = 0;
      }

      conceptos.envio_domicilio.precio = 0;
      if (this.notificacion.envio_domicilio) {
        conceptos.envio_domicilio.cantidad = 1;
      } else {
        conceptos.envio_domicilio.cantidad = 0;
      }

      const cuponBackup = Object.assign({}, this.notificacion.cotizacion.conceptos.cupon_info);
      this.borrarCupon();
      Object.assign(this.notificacion.cotizacion.conceptos.cupon_info, cuponBackup);
      this.nombreCuponDescuento = cuponBackup.nombre;
      this.calcularCostoTotal();
    },

    fillCotizacion() {
      const conceptos = this.notificacion.cotizacion.conceptos;

      this.subtotal_zona = conceptos.domicilio_notificacion.precio;
      this.costoTotal = this.subtotal_zona;

      if (conceptos.acta_express.tiene_acta_express) {
        this.subtotal_extras = this.subtotal_extras + conceptos.acta_express.precio;
        this.notificacion.acta_express = true;
        // this.precio_acta = conceptos.acta_express.precio;
      }

      if (conceptos.documento_adicional.cantidad) {
        this.precio_total_documentos_adicionales = conceptos.documento_adicional.cantidad * conceptos.documento_adicional.precio;
        this.cantidad_documentos_adicionales = conceptos.documento_adicional.cantidad;
        this.subtotal_documentos = this.subtotal_documentos + this.precio_total_documentos_adicionales;
      }

      if (conceptos.pagina_adicional.cantidad) {
        this.precio_total_paginas_extra = conceptos.pagina_adicional.cantidad * conceptos.pagina_adicional.precio;
        this.paginas_extra = conceptos.pagina_adicional.cantidad;
        this.subtotal_documentos = this.subtotal_documentos + this.precio_total_paginas_extra;
      }

      if (conceptos.fad.tiene_fad) {
        // this.precio_fad = conceptos.fad.precio;
        this.subtotal_documentos = this.subtotal_documentos + conceptos.fad.precio;
      }

      if (conceptos.envio_domicilio.tiene_envio_domicilio) {
        this.notificacion.envio_domicilio = 1;
      }

      if (conceptos.contenido_digital.tiene_contenido_digital) {
        this.notificacion.contenido_digital = 1;
        this.subtotal_documentos = this.subtotal_documentos + conceptos.contenido_digital.precio;
        // this.precio_contenido_digital = conceptos.contenido_digital.precio;
      }

      this.costoTotal = this.subtotal_zona + this.subtotal_documentos + this.subtotal_extras;

      if (conceptos.cupon_info?.id) {
        this.cuponAplicado = true;
        this.nombreCuponDescuento = conceptos.cupon_info.nombre;

        const tipo = conceptos.cupon_info.tipo;
        const descuento = conceptos.cupon_info.descuento;
        const total = this.costoTotal;

        if (tipo === "Porcentaje") {
          let descuentoDecimal = descuento;
          if (descuento > 1) {
            descuentoDecimal = descuento / 100;
          }

          let precio_total = total * (1 - descuentoDecimal);
          this.costoTotal = precio_total;
          this.cantidadDescuentoCupon = "% " + descuentoDecimal * 100;
          this.cantidadDescontadaCupon = total * descuentoDecimal;
        } else if (tipo === "Monto") {
          let precio_total = total - descuento;

          this.costoTotal = precio_total;
          this.cantidadDescuentoCupon = "$ " + descuento;
          this.cantidadDescontadaCupon = descuento;
        }

        this.notificacion.cotizacion.cupones_id = conceptos.cupon_info.id;
      }
    },

    async getGastos() {
      const { value } = await CatGastosApi.list({
        page: 0,
        registersPerPage: 0,
        cat_servicios_id: "2",
      });

      this.cat_gastos = value;

      for (const gasto in this.cat_gastos) {
        if (this.cat_gastos[gasto]["clave"] === "acta_express") {
          this.precio_acta = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_persona_fisica") {
          this.precio_adicional_fisica = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_persona_moral") {
          this.precio_adicional_moral = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "adicional_representante") {
          this.precio_adicional_representante = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "pagina_adicional") {
          this.precio_pagina_adicional = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "contenido_digital") {
          this.precio_contenido_digital = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "fad_documento_principal") {
          this.precio_fad = this.cat_gastos[gasto]["costo"];
        }
        if (this.cat_gastos[gasto]["clave"] === "documento_adicional") {
          this.precio_documento_adicional = this.cat_gastos[gasto]["costo"];
        }
      }
    },

    calculaDocumentos() {
      // Calcula los documentos principales eliminando 1 incluido
      this.cantidad_documentos_adicionales = this.notificacion.documentos.length - 1;
      // Descarta los anexos
      this.notificacion.documentos.forEach((documento) => {
        if (documento.anexoDe) {
          this.cantidad_documentos_adicionales -= 1;
        }
      });

      // Cantidad de paginas totales
      let paginas_totales = 0;
      this.notificacion.documentos.forEach((documento) => {
        paginas_totales += parseInt(documento.paginas);
      });

      this.paginas_extra = Math.max(paginas_totales - 50, 0);

      this.notificacion.cotizacion.conceptos.documento_adicional = {
        cantidad: this.cantidad_documentos_adicionales,
        precio: this.precio_documento_adicional,
      };
      this.precio_total_documentos_adicionales = this.cantidad_documentos_adicionales * this.precio_documento_adicional;

      this.notificacion.cotizacion.conceptos.pagina_adicional = {
        cantidad: this.paginas_extra,
        precio: this.precio_pagina_adicional,
      };
      this.precio_total_paginas_extra = this.paginas_extra * this.precio_pagina_adicional;

      this.notificacion.cotizacion.conceptos.fad = {
        cantidad: this.notificacion.fad ? 1 : 0,
        precio: this.precio_fad,
      };
      this.notificacion.cotizacion.conceptos.contenido_digital = {
        cantidad: this.notificacion.contenido_digital ? 1 : 0,
        precio: this.precio_contenido_digital,
      };
    },

    calcularCostoAntesExtrasDescuentos() {
      const conceptos = this.notificacion.cotizacion.conceptos;
      const costoAntesExtrasDescuentos = conceptos.domicilio_notificacion.precio
        + conceptos.documento_adicional.cantidad * conceptos.documento_adicional.precio
        + conceptos.pagina_adicional.cantidad * conceptos.pagina_adicional.precio
        + conceptos.contenido_digital.cantidad * conceptos.contenido_digital.precio
        + conceptos.fad.cantidad * conceptos.fad.precio;

      conceptos.costo_antes_extras_descuentos = costoAntesExtrasDescuentos;

      return costoAntesExtrasDescuentos;
    },

    calcularCostoConExtras() {
      const conceptos = this.notificacion.cotizacion.conceptos;
      const costoConExtras =
        conceptos.envio_domicilio.cantidad * conceptos.envio_domicilio.precio
        + conceptos.acta_express.cantidad * conceptos.acta_express.precio;

      conceptos.costo_con_extras = costoConExtras;

      return costoConExtras;
    },

    calcularCostoTotal() {
      let total = this.calcularCostoAntesExtrasDescuentos() + this.calcularCostoConExtras();

      if (!this.notificacion.cotizacion.conceptos.cupon_info.id) {
        this.notificacion.cotizacion.conceptos.costo_total = total;
        return;
      }

      if (this.notificacion.cotizacion.conceptos.cupon_info.tipo === "Porcentaje") {
        let descuentoDecimal = this.notificacion.cotizacion.conceptos.cupon_info.descuento;
        if (this.notificacion.cotizacion.conceptos.cupon_info.descuento > 1) {
          descuentoDecimal = this.notificacion.cotizacion.conceptos.cupon_info.descuento / 100;
        }

        total = total * (1 - descuentoDecimal);

        this.cantidadDescuentoCupon = "% " + descuentoDecimal * 100;
        this.cantidadDescontadaCupon = total * descuentoDecimal;
      } else if (this.notificacion.cotizacion.conceptos.cupon_info.tipo === "Monto") {
        total = total - this.notificacion.cotizacion.conceptos.cupon_info.descuento;

        this.cantidadDescuentoCupon = "$ " + this.notificacion.cotizacion.conceptos.cupon_info.descuento;
        this.cantidadDescontadaCupon = this.notificacion.cotizacion.conceptos.cupon_info.descuento;
      }

      this.cuponAplicado = true;
      this.notificacion.cotizacion.conceptos.costo_total = total;
      this.notificacion.cotizacion.cupones_id = this.notificacion.cotizacion.conceptos.cupon_info.id;

      this.notificacion.cotizacion.conceptos.cupon_info = {
        id: this.notificacion.cotizacion.conceptos.cupon_info.id,
        nombre: this.nombreCuponDescuento,
        tipo: this.notificacion.cotizacion.conceptos.cupon_info.tipo,
        descuento: this.notificacion.cotizacion.conceptos.cupon_info.descuento,
      };

      return total;
    },

    async validarCupon() {
      try {
        this.uiState.startLoading();

        const time_zone = -(new Date().getTimezoneOffset() / 60);
        const data = {
          nombre: this.nombreCuponDescuento,
          timeZone: time_zone,
        };
        const { id, isValid, tipo, descuento, message } = await CuponesApi.cuponValido(data);

        if (!isValid) {
          this.$toast.warning(message, {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });

          this.nombreCuponDescuento = "";

          return;
        }

        this.notificacion.cotizacion.conceptos.cupon_info.id = id;
        this.notificacion.cotizacion.conceptos.cupon_info.tipo = tipo;
        this.notificacion.cotizacion.conceptos.cupon_info.descuento = descuento;
        this.notificacion.cotizacion.conceptos.cupon_info.nombre = this.nombreCuponDescuento;

        this.calcularCostoTotal();

        // En este momento ya se deja al componenete padre actualizar o crear la cotizacion con el nuevo precio
        this.$toast.success("El cupón se aplicó correctamente", {
          timeout: 3000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);

        this.$toast.error("Ocurrió un error al aplicar el cupón.", {
          timeout: 3000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.uiState.stopLoading();
      }
    },

    borrarCupon() {
      this.notificacion.cotizacion.cupones_id = null;
      this.notificacion.cotizacion.conceptos.cupon_info.id = null;
      this.notificacion.cotizacion.conceptos.cupon_info.tipo = null;
      this.notificacion.cotizacion.conceptos.cupon_info.descuento = null;
      this.notificacion.cotizacion.conceptos.cupon_info.nombre = null;
      this.nombreCuponDescuento = null;
      this.cantidadDescuentoCupon = 0;
      this.cantidadDescontadaCupon = 0;
      this.cuponAplicado = false;

      this.calcularCostoTotal();
    },
  },
};
</script>

<style scoped>
.container >>> .form-check-sign {
  display: inline-block;
  padding-top: 20px;
}

.table-fixed {
  table-layout: fixed;
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 8px;
  text-align: left;
}

.check-col {
  width: 10%;
  /* Ancho ajustado para la columna Check */
}

.descripcion-col {
  width: 70%;
  /* Ajusta este valor según sea necesario */
}

.precio-col {
  width: 20%;
  /* Ajusta este valor según sea necesario */
}

.precio-col-container {
  display: flex;
  justify-content: flex-end;
}

.total {
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
